import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export type GuideLanguage = 'en' | 'it';

@Component({
	standalone: true,
	selector: 'bt-guide-language-modal',
	imports: [MatDialogModule],
	templateUrl: './guide-language-modal.component.html',
	styleUrls: ['./guide-language-modal.component.scss']
})
export class GuideLanguageModalComponent {
	readonly #dialogRef = inject(MatDialogRef<GuideLanguageModalComponent>);

	selectLanguage(language: GuideLanguage): void {
		this.#dialogRef.close(language);
	}
}
